import { css } from "styled-components";
import { BladeHeader, BladeHeaderTitle } from "../../../../components/BladeHeader";
import { AccordionHeader } from "../../../../components/Accordion";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.topLarge};
  }

  ${BladeHeader} {
    display: flex;
    gap: ${chroma.spacers.variable.m};
    justify-content: space-between;
    margin-bottom: ${chroma.spacers.variable.sm};
  }

  ${BladeHeaderTitle} {
    ${chroma.typography.body2};
    font-weight: 600;
  }
  ${AccordionHeader} > button {
    font-weight: 600;
  }
`;
//# sourceMappingURL=index.js.map